package com.example.hukakmp.ui

import androidx.compose.runtime.Composable

data class TutorialStoreState(
    val hasSeen: Boolean,
    val markSeen: () -> Unit,
    val reset: () -> Unit,
)

@Composable
expect fun rememberMainTutorialStore(): TutorialStoreState
